<template>
  <div>
    <el-dialog v-model="dialogVisible" :title="formData.title" width="600" destroy-on-close @close="beforeclose">
      <div>
        <el-form ref="formRef" :model="formData" label-width="auto" label-suffix="：" label-position="top">
          <el-form-item label="表格描述" prop="queDesc">
            <rich-text-input use-base64 v-model="formData.desc"></rich-text-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ElMessage } from "element-plus";

const dialogVisible = ref(false);

const formData = ref({
  type: "",
  title: "",
  desc: "",
});
const formRef = ref(null);
const open = (options = {}) => {
  Object.assign(formData.value, options);
  dialogVisible.value = true;
};
const close = () => {
  dialogVisible.value = false;
};
const beforeclose = () => {
  formData.value = {
    type: "",
    title: "",
    desc: "",
  };
};
const submitForm = () => {
  emits("submit", formData.value);
  close();
};

const emits = defineEmits(["submit"]);
defineExpose({
  open,
});
</script>

<style lang="scss" scoped></style>
